import { useTranslation } from "react-i18next";
import type { IDeleteModalProps } from "@app/dashboard/types/innerLayout/iframes/delete-iframe";
import type { IButton } from "libs/design-system/src/types/Button/button";
import type { IModalSharedProps } from "libs/design-system/src/types/modal";
import { Check, Xmark } from "libs/design-system/src/assets/Icons";
import { Modal, StatusIndicator } from "@unified-checkout/design-system";


export const DeleteModal = ({
  open,
  isLoading,
  isError,
  isSuccess,
  selectedIframeId,
  onClose,
  onConfirm,
}: IDeleteModalProps) => {
  const { t } = useTranslation();

  const isProcessDone = isSuccess || isError

  const title = isProcessDone ?
    ''
    :
    t(`innerLayout.iFramesPage.deleteModal.title`);

  const description = isProcessDone ?
    undefined
    :
    t(`innerLayout.iFramesPage.deleteModal.desc`).replace('{id}', selectedIframeId ? selectedIframeId.toString() : '');

  const btns = isProcessDone ?
    undefined
    :
    [
      {
        size: "md",
        color: "danger",
        variant: "contained",
        text: t(`innerLayout.iFramesPage.deleteModal.confirmButton`),
        onClickHandler: onConfirm,
        loading: isLoading,
        disabled: isLoading,
      } as IButton,
      {
        size: "md",
        color: "secondary",
        variant: "outlined",
        text: t("innerLayout.iFramesPage.deleteModal.cancelButton"),
        onClickHandler: onClose,
      } as IButton,
    ]

  const huintText = isSuccess ?
    t("innerLayout.iFramesPage.deleteModal.deleteSuccesMessage")
    :
    t("innerLayout.errors.smthWentWrong")

  const modalProps: IModalSharedProps = {
    state: "default",
    open,
    hasCloseIcon: isProcessDone,
    onCloseHandler: onClose,
    closeOnClickOutside: true,
    title,
    supportingText: description,
    btnsProps: btns
  }

  const status = isProcessDone ?
    (
      <StatusIndicator
        status={isSuccess ? "success" : "error"}
        icon={isSuccess ? Check : Xmark}
        hintText={huintText}
      />
    )
    :
    null

  return (
    <Modal {...modalProps}>
      {status}
    </Modal>
  );
};
